import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { ClipboardList, Plus, User, ChevronLeft } from 'lucide-react'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { MobileDataProvider } from './MobileDataContext'
import './mobile.css'

/* ── Root shell: fixed viewport + data provider ───────────── */
export function MobileShell() {
  return (
    <MobileDataProvider>
      <div className="m-app">
        <Outlet />
      </div>
    </MobileDataProvider>
  )
}

/* ── Tabbed layout (bottom nav) for top-level screens ─────── */
export function MobileTabs() {
  const { t } = useTranslation('pages')
  return (
    <>
      <Outlet />
      <nav className="m-bottomnav">
        <NavLink to="/m" end className={({ isActive }) => `m-navitem${isActive ? ' active' : ''}`}>
          <ClipboardList />
          <span>{t('mobile.layout.exams')}</span>
        </NavLink>
        <NavLink
          to="/m/exams/new"
          className={({ isActive }) => `m-navitem${isActive ? ' active' : ''}`}
        >
          <Plus />
          <span>{t('mobile.layout.new')}</span>
        </NavLink>
        <NavLink
          to="/m/profile"
          className={({ isActive }) => `m-navitem${isActive ? ' active' : ''}`}
        >
          <User />
          <span>{t('mobile.layout.profile')}</span>
        </NavLink>
      </nav>
    </>
  )
}

/* ── Reusable top bar ─────────────────────────────────────── */
export function MTopbar({
  title,
  subtitle,
  back,
  backTo,
  right,
}: {
  title: ReactNode
  subtitle?: ReactNode
  back?: boolean
  backTo?: string
  right?: ReactNode
}) {
  const { t } = useTranslation('pages')
  const navigate = useNavigate()
  return (
    <header className="m-topbar">
      {back && (
        <button
          className="m-iconbtn"
          aria-label={t('mobile.layout.back')}
          onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
        >
          <ChevronLeft />
        </button>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="m-topbar-title">{title}</div>
        {subtitle && <div className="m-topbar-sub">{subtitle}</div>}
      </div>
      {right}
    </header>
  )
}
